import { useState } from 'react';
import { useGetShiftPendingReviews } from '~/domain/ShiftReview/usecases';

interface IProps {
  limit?: number;
}

export const usePendingShiftReviews = ({ limit = 10 }: IProps) => {
  const [page, setPage] = useState(1);

  const { data, isLoading, isFetching } = useGetShiftPendingReviews({
    page,
    limit,
  });

  const isInitialLoading = page === 1 && (isLoading || isFetching);

  const onPageChanged = (newPage: number) => {
    setPage(newPage);
  };

  return {
    data: data?.data || [],
    isInitialLoading,
    isLoading: isLoading || isFetching,
    limit: data?.limit || limit,
    page: data?.page || 1,
    total: data?.total || 0,
    onPageChanged,
  };
};
